/* oxlint-disable formatjs/no-literal-string-in-jsx -- Please check and fix */
import { type ReactNode, useState } from 'react';
import { Spinner } from '@repo/design-system-kit/components/spinner/spinner';
import cx from 'clsx';
import styles from './iframe.module.css';

export interface IframeProps {
  src: string;
}

export function Iframe({ src }: IframeProps): ReactNode {
  const [loaded, setLoaded] = useState(false);

  return (
    <>
      {!loaded && (
        <div className={styles.spinnerContainer}>
          <Spinner size="large" />
        </div>
      )}
      <iframe
        allow="camera; microphone"
        className={cx(styles.iframe, !loaded && styles.hidden)}
        data-test-idnow-iframe
        onLoad={() => {
          setLoaded(true);
        }}
        src={src}
        title="idnow"
      />
    </>
  );
}
